<template>
  <div class="p-8">
      <div class="flex flex-col md:flex-row justify-between">
          <div class="flex items-center">
              <span 
                :class="['relative flex justify-center items-center w-7 h-7 rounded-full mr-1', 
                homeContent.chartHome.headerChartHome.background, homeContent.chartHome.headerChartHome.color]">
                    <i :class="homeContent.chartHome.headerChartHome.icon"></i>
              </span>
              <h2>{{homeContent.chartHome.headerChartHome.title + getCat.name}} </h2>
          </div>
          <div class="flex items-center">
              <select name="catHome" v-model="referenciaProductos" class="flex bg-white border-2 border-gray-200 justify-center items-center py-2 px-2 rounded-md text-t14 text-costeaDarkGray">
                  <option v-for="prod in getProd" :key="prod.index" :value="prod.id">{{prod.nombre}}</option>
                  <option v-if="getProd <= 0" value="0">No hay productos</option>
              </select>
              <button class="flex font-costea text-t14 text-costeaPrimary bg-costeaPrimaryDisabled hover:text-white hover:bg-costeaPrimary px-4 py-2 rounded-md ml-3">Exportar</button>              
              <!--<button @click="$router.push({path: 'reportes'})" class="flex font-costea text-t16 text-costeaPurple bg-costeaPurpleDisabled hover:text-white hover:bg-costeaPurple px-4 py-2 ml-4 rounded-md">Reportes avanzados</button>-->
          </div>
      </div>
      <div>
          <HomeChart @referenciaProductos="referenciaProductos"/>
      </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import HomeChart from '@/components/home/HomeChart.js'
import axios from 'axios'
export default {
components:{
    HomeChart
},
data(){
    return{
        products: [],
        categories: [],
        referenciaProductos: '',
    }
},

props:{
    catSelected: Number
},
computed:{
    ...mapState(['homeContent']),
    ...mapState(['costea']),
    getCat(){
        let cat = {id: '', name: ''}
        this.categories.find(c => {if(c.id == this.catSelected){cat.id = c.id}})
        this.categories.find(c => {if(c.id == this.catSelected){cat.name = c.name}})
        return cat
    },
    getProd(){
        let prod = this.products.filter(producto =>{
            return producto.id_category === this.getCat.id
        })
        return prod
    }
},
methods:{
    getProduct(){
        axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}categories`).then(res =>{
            this.categories = res.data
            if(res.data.status == false){
                this.$router.push('/login')
            }
        }).catch (
                (error) => {
                    if(error.response.status === 401){
                        this.$router.push('/login')
                    }
                }
            );
        axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}productos`).then(res =>{
            this.products = res.data
        }).catch (
                (error) => {
                    if(error.response.status === 401){
                        this.$router.push('/login')
                    }
                }
            );
    }
},
mounted(){
    this.getProduct()
    this.getCat
    this.getProd
}
}
</script>

<style>

</style>